import { SVGProps } from "react";

export const TextDeleteIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 1C22.5523 1 23 1.44772 23 2V14C23 14.5523 22.5523 15 22 15H7.56556C7.2768 15 7.00214 14.8752 6.81224 14.6577L1.57415 8.65766C1.24523 8.2809 1.24523 7.71909 1.57415 7.34234L6.81224 1.34234C7.00214 1.12482 7.2768 1 7.56556 1H22Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11 5L17 11M17 5L11 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);
